import { CircuitBoard, Cpu, MemoryStick, MonitorSmartphone, Wifi } from "lucide-react";
import { useLang } from "./LangContext";
import { useSettings, has } from "./SettingsContext";
import { ChapterHead, FadeUp, Soon } from "./Reveal";
import { HourlyPrice } from "./HourlyPrice";
import { PriceItems } from "./PriceItems";

const ICONS = {
  gpu: CircuitBoard,
  cpu: Cpu,
  ram: MemoryStick,
  monitor: MonitorSmartphone,
  wifi: Wifi,
};

export default function Systems() {
  const { t } = useLang();
  const { settings } = useSettings();
  const s = t.systems;

  return (
    <section id="sistemler" className="section" data-testid="systems-section">
      <div className="wrap">
        <ChapterHead num={s.num} label={s.label} title={s.title} lead={s.lead} />
        <div className="sys-grid sys-grid-dual">
          {["systems", "systems2"].map((sysKey, panelIndex) => (
            <FadeUp delay={panelIndex * 0.1} key={sysKey}>
              <div className="spec-panel" data-testid={`systems-spec-panel-${panelIndex}`}>
                <div className="spec-panel-head">
                  <span className="spec-panel-title font-display" data-testid={`systems-spec-title-${panelIndex}`}>
                    {s.systemLabels[panelIndex]}
                  </span>
                  <span className="spec-panel-sub">{s.systemsSub}</span>
                </div>
                {s.specs.map((spec, i) => {
                  const Icon = ICONS[spec.icon];
                  const value = settings?.[sysKey]?.[spec.icon === "wifi" ? "internet" : spec.icon];
                  return (
                    <div className="spec-row" key={spec.key} data-testid={`spec-row-${panelIndex}-${i}`}>
                      <span className="spec-icon" aria-hidden="true">
                        <Icon size={22} strokeWidth={1.8} />
                      </span>
                      <span>
                        <span className="spec-key font-display">{spec.key}</span>
                        <span className="spec-label">{spec.label}</span>
                      </span>
                      {has(value) ? (
                        <span className="spec-value" data-testid={`spec-value-${panelIndex}-${i}`}>
                          {value}
                        </span>
                      ) : (
                        <Soon text={s.soon} testid={`spec-soon-${panelIndex}-${i}`} />
                      )}
                    </div>
                  );
                })}
              </div>
            </FadeUp>
          ))}
        </div>
        <FadeUp delay={0.15}>
          <div className="sys-media sys-media-wide" data-testid="systems-media">
            <img src="/img/rig.jpeg" alt={s.imgAlt} loading="lazy" decoding="async" />
            <div className="sys-veil" aria-hidden="true" />
            <p className="strip-caption">
              <span className="diamond" aria-hidden="true">◆</span>
              {s.imgCaption}
            </p>
          </div>
        </FadeUp>
        <div className="systems-pricing" data-testid="systems-pricing">
          <h3 className="font-display" data-testid="systems-pricing-title">{t.pricing.title}</h3>
          <div className="price-branches">
            {t.branches.items.map((branch) => (
              <div className="price-branch-col" key={branch.id} data-testid={`systems-price-branch-${branch.id}`}>
                <div className="price-branch">
                  <span className="price-city">{branch.city} · {t.pricing.pc}</span>
                  <HourlyPrice value={settings?.prices?.[branch.id]} testid={`systems-price-${branch.id}`} />
                </div>
                <PriceItems items={settings?.price_items?.[branch.id]} testid={`systems-price-items-${branch.id}`} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
